export default __webpack_public_path__ + "static/media/chevron_right_arrow.8df37eb1.svg";